export const LeftBoxIntro = `
Data Analyst | Business & Systems Analysis | Analytics & Automation
`;

export const skillSets = [
  {
    category: "SQL & Data Management",
    skills: "SQL|PostgreSQL|MySQL|ETL|Data Modelling|Data Warehousing",
  },
  {
    category: "Data Processing & Automation",
    skills: "Python|Bash/Shell|Pandas|NumPy|REST APIs|GitHub",
  },
  {
    category: "Reporting & Visualisation",
    skills: "Power BI|Tableau|Excel",
  },
  {
    category: "Data Analysis",
    skills: "Data Validation|Data Cleaning|Exploratory Analysis|Operational Reporting",
  },
  {
    category: "Business & Operations Analysis",
    skills: "Process Optimisation|Logistics & Supply Chain Analysis|Cost Analysis|Systems Analysis",
  },
  {
    category: "Advanced Analytics",
    skills: "Statistical Modelling|Machine Learning|NLP|Bayesian Methods",
  },
];


export const mottos = [
  `"The only thing we have to fear is fear itself."\nFranklin D. Roosevelt`,
  `"Success is not final, failure is not fatal: It is the courage to continue that counts."\nWinston Churchill`,
  `"Stay hungry, stay foolish."\nSteve Jobs`,
  `"Our intelligence is what makes us human, and AI is an extension of that quality."\nYann LeCun`,
  `"I propose to consider the question, 'Can machines think?' " \nAlan Turing`,
  `"The value of an idea lies in the using of it."\nThomas Edison`,
];
